import { CallRounded } from '@mui/icons-material'
import { Link } from '@mui/material'
import { useSendForm } from 'feature/productOrder/hooks/useSendForm'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { useUploadConsultationImageMutation } from 'feature/productOrder/redux/orders.api'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { FC, useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Modal } from 'ui'
import { ModalOrderCall } from 'widget/ModalOrderCall/ModalOrderCall'
import style from './OrderBlock.module.scss'

interface IConsultationModal {
  isOpen: boolean
  onClose: () => void
}

const consultationDescription = (
  <>
    Необходима помощь в выборе изделия? Оставьте необходимую информацию, и мы с
    Вами свяжемся!
    <br />
    <br />
    <span className={style.boldTitle}>Нужна срочная консультация?</span>
    <br />
    Позвоните нам: <Link href='tel:88002002208'>8 800 200-22-08</Link>
  </>
)

// модальное окно для консультации (Консультация перед покупкой)
export const ConsultationModal: FC<IConsultationModal> = ({
  isOpen,
  onClose,
}) => {
  const [uploadImage] = useUploadConsultationImageMutation()
  const [fileList, setFileList] = useState<orderFormSpace.Images[]>([])
  const [isBtnLoading, setBtnLoading] = useState(false)
  const { sendForm, isError } = useSendForm()
  const { setConsultationImages } = useActions()
  const handleSubmitModal = () => {
    setBtnLoading(true)
    sendForm()
    removeModalScrollSafari(false)
  }

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setBtnLoading(false)
      }, 1000)
    }
  }, [isError])

  const loadFile = async (file: File) => {
    const ImgData = await uploadImage(file).unwrap()
    return ImgData
  }

  const images: orderFormSpace.Images[] = useAppSelector(
    state => state.orderForm.consultationForms.consultation.images,
  )

  const [imgDisabled, setImgDisabled] = useState(false)

  useEffect(() => {
    const validCount = images.reduce(
      (all, cur) => (cur.serverUid ? all + 1 : all - 1),
      0,
    )
    if (validCount === images.length) {
      setImgDisabled(false)
    } else setImgDisabled(true)
  }, [images])

  const handleClose = () => {
    setConsultationImages(images.filter(item => item.previewUrl !== null))
    onClose()
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalOrderCall
        close={handleClose}
        onSubmit={handleSubmitModal}
        formType={orderFormSpace.ConsultationFormType.consultation}
        fileList={fileList}
        btnLoading={isBtnLoading}
        btnDisabled={imgDisabled}
        setFileList={setFileList}
        loadFile={loadFile}
        title='Консультация перед покупкой'
        description={consultationDescription}
        submitButtonText='Заказать звонок'
        SubmitButtonIcon={<CallRounded />}
      />
    </Modal>
  )
}
